module.exports = __webpack_public_path__ + "static/media/prpg1.f15e9d20.png";